/**
 * Shared Layout Component for Checkout Pages
 * Provides the gradient background and container structure
 */

import React from 'react';

interface CheckoutLayoutProps {
  children: React.ReactNode;
  title: string;
  subtitle: string;
}

export const CheckoutLayout: React.FC<CheckoutLayoutProps> = ({ children, title, subtitle }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-violet-50 via-kind-deep to-blue-50 dark:from-violet-950 dark:via-kind-deep dark:to-blue-950">
      <div className="max-w-4xl mx-auto px-4 py-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-title font-medium text-kind-text-primary mb-4">{title}</h1>
          <p className="text-xl font-body font-light text-kind-text-secondary max-w-2xl mx-auto">
            {subtitle}
          </p>
        </div>

        {children}
      </div>
    </div>
  );
};
